export default "__VITE_ASSET__DMvjDpq7__"